import React, {useEffect, useState} from 'react';
import makeApiCall from '../../api/makeApiCall';
import {
  branchList,
  createdByList,
  stateList,
} from '../../api/request/leadApi/leadApi';
import {Grid} from '@mui/material';
import FilterComp from './filterComp';
// import {toast} from 'react-toastify';
import Strings from '../../constants/stringConstant';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {setFilterValue} from '../../state/slice/filterSlice';
import {setPayLoadValue} from '../../state/slice/leadListPayloadSlice';
import {setMccPayLoadValue} from '../../state/slice/mccListSlice';
import {setPlatformPayLoadValue} from '../../state/slice/platformListPayloadSlice';
import {setLoanPayLoadValue} from '../../state/slice/loanListPayloadSlice';
const CombinedFilter = ({fetchData, dashboardType}) => {
  const dispatch = useDispatch();
  const {filters} = useSelector(state => state.filterValue);

  const [filterConfigs, setFilterConfigs] = useState([]);

  useEffect(() => {
    getFilters();
  }, []);
  function getFilters() {
    const filterValues = [
      {
        filterType: 'State',
        options: [],
        buttonName: 'State',
        filterKey: 'stateId',
        filterName: 'stateName',
      },
      {
        filterType: 'Branch',
        options: [],
        buttonName: 'Branch',
        filterKey: 'branchId',
        filterName: 'branchName',
      },
      {
        filterType: 'CreatedBy',
        options: [],
        buttonName: 'Created By',
        filterKey: 'userId',
        filterName: 'fullName',
      },
    ];

    // Always show all filters - no role-based filtering
    setFilterConfigs(filterValues);

    fetchStateData();
    fetchBranchData();
    fetchCreatedData();
  }
  const fetchStateData = async () => {
    try {
      const response = await makeApiCall(stateList());

      if (response.data.status === Strings.success) {
        setFilterConfigs(prevConfigs =>
          prevConfigs.map(config =>
            config.filterType === 'State'
              ? {...config, options: response.data.data}
              : config,
          ),
        );
      } else {
        if (response.data.status === Strings.error) {
          console.log('error');
        }
      }
    } catch (error) {
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
      console.log('failed:', error);
    }
  };

  const fetchBranchData = async selectedState => {
    try {
      const response = await makeApiCall(
        branchList({state: selectedState || ['']}),
      );
      if (response.data.status === Strings.success) {
        // store the options
        setFilterConfigs(prevConfigs =>
          prevConfigs.map(config =>
            config.filterType === 'Branch'
              ? {...config, options: response.data.data}
              : config,
          ),
        );
        const tempArray = response.data.data.filter(data =>
          filters.Branch.includes(data?.branchId),
        );

        // remove the selected filter value doesnt exist
        dispatch(
          setFilterValue({
            filters: {
              Branch: tempArray.map(data => data.branchId),
            },
          }),
        );

        return tempArray.map(data => data.branchId);
      } else {
        if (response.data.status === Strings.error) {
          setFilterConfigs(prevConfigs =>
            prevConfigs.map(config =>
              config.filterType !== 'State' ? {...config, options: []} : config,
            ),
          );
          dispatch(
            setFilterValue({
              filters: {
                Branch: [],
              },
            }),
          );

          return [];
        }
      }
    } catch (error) {
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
      console.log('failed:', error);
    }
  };

  const fetchCreatedData = async (selectedState, selectedBranch) => {
    try {
      const response = await makeApiCall(
        createdByList({
          state: selectedState || [],
          branchId: selectedBranch || [],
        }),
      );

      if (response.data.status === Strings.success) {
        // store the options
        setFilterConfigs(prevConfigs =>
          prevConfigs.map(config =>
            config.filterType === 'CreatedBy'
              ? {...config, options: response.data.data}
              : config,
          ),
        );
        const tempArray = response.data.data.filter(data =>
          filters.CreatedBy.includes(data?.userId),
        );
        // remove the selected filter value doesnot exist
        dispatch(
          setFilterValue({
            filters: {
              CreatedBy: tempArray.map(data => data.userId),
            },
          }),
        );

        return tempArray.map(data => data.userId);
      } else {
        if (response.data.status === Strings.error) {
          setFilterConfigs(prevConfigs =>
            prevConfigs.map(config =>
              config.filterType === 'CreatedBy'
                ? {...config, options: []}
                : config,
            ),
          );
          dispatch(
            setFilterValue({
              filters: {
                CreatedBy: [],
              },
            }),
          );
          console.log('error');

          return [];
        }
      }
    } catch (error) {
      // toast.error(Strings.apiError, {
      //   position: 'top-right',
      // });
    }
  };
  const handleDashboardType = () => {
    switch (dashboardType) {
      case Strings.leadManagement.lead_type:
        dispatch(setPayLoadValue({currentPage: 1}));
        break;
      case Strings.mcc_dashboard.mcc_type:
        dispatch(setMccPayLoadValue({currentPage: 1}));
        break;
      case Strings.platform_management.platform_type:
        dispatch(setPlatformPayLoadValue({currentPage: 1}));
        break;
      case Strings.loan_applications.dashboard_type_qde:
      case Strings.loan_applications.dashboard_type_dde:
      case Strings.loan_applications.dashboard_type_fi:
      case Strings.loan_applications.dashboard_type_review_fi:
      case Strings.loan_applications.dashboard_type_review_cd:
      case Strings.loan_applications.dashboard_type_personal_dis:
      case Strings.loan_applications.application_type_rejected:
      case Strings.loan_applications.application_type_onhold:
      case Strings.loan_applications.application_type_con_dis:
      case Strings.loan_applications.application_type_order_con:
      case Strings.loan_applications.application_type_eligibility:
      case Strings.loan_applications.application_type_approval_flow:
      case Strings.loan_applications.application_type_loan_booking:
      case Strings.loan_applications.application_type_doc_esign:
      case Strings.loan_applications.application_type_doc_verify:
      case Strings.loan_applications.application_type_part_approval:
      case Strings.loan_applications.application_type_disbursement:
        dispatch(setLoanPayLoadValue({currentPage: 1}));
        break;
      default:
        break;
    }
  };
  const handleFilterChange = async (filterType, checkedValues) => {
    let newFilters = {...filters};

    if (filterType === 'State') {
      const stateChanged =
        JSON.stringify(filters.State) !== JSON.stringify(checkedValues);

      if (stateChanged) {
        // Clear dependent filters
        newFilters = {
          ...newFilters,
          State: checkedValues,
          Branch: [],
          CreatedBy: [],
        };

        // Dispatch early so UI updates immediately
        dispatch(setFilterValue({filters: newFilters}));
        handleDashboardType();

        // Don't fetch if no states selected
        if (checkedValues.length > 0) {
          const branchArray = await fetchBranchData(checkedValues);
          const createdArray = await fetchCreatedData(
            checkedValues,
            branchArray,
          );
          fetchData(checkedValues, branchArray, createdArray, 1);
        } else {
          // No state selected, send empty filters
          fetchData([], [], [], 1);
        }
      }
    } else if (filterType === 'Branch') {
      const branchChanged =
        JSON.stringify(filters.Branch) !== JSON.stringify(checkedValues);

      if (branchChanged) {
        newFilters = {
          ...newFilters,
          Branch: checkedValues,
          CreatedBy: [],
        };

        dispatch(setFilterValue({filters: newFilters}));
        handleDashboardType();

        if (checkedValues.length > 0) {
          const createdArray = await fetchCreatedData(
            filters.State,
            checkedValues,
          );
          fetchData(filters.State, checkedValues, createdArray, 1);
        } else {
          fetchData(filters.State, [], [], 1);
        }
      }
    } else if (filterType === 'CreatedBy') {
      const createdChanged =
        JSON.stringify(filters.CreatedBy) !== JSON.stringify(checkedValues);

      if (createdChanged) {
        newFilters = {
          ...newFilters,
          CreatedBy: checkedValues,
        };

        dispatch(setFilterValue({filters: newFilters}));

        handleDashboardType();
        fetchData(filters.State, filters.Branch, checkedValues, 1);
      }
    }
  };

  return (
    <Grid container gap={1}>
      {filterConfigs.map(
        ({filterType, options, buttonName, filterKey, filterName}) => (
          <Grid item key={filterType}>
            <FilterComp
              filterSelected={filters[filterType]}
              buttonName={buttonName}
              filterType={filterType}
              filterKey={filterKey}
              filterName={filterName}
              options={options}
              onFilterChange={handleFilterChange}
            />
          </Grid>
        ),
      )}
    </Grid>
  );
};
CombinedFilter.propTypes = {
  fetchData: PropTypes.func,
  dashboardType: PropTypes.string,
};
export default CombinedFilter;
